export const CHILDREN_LAYOUT_CONTENT = 'content';
